// Shared utility for severity color calculations

export interface ColorStop {
  score: number;
  color: string;
}

export const colorStops: ColorStop[] = [
  { score: 10, color: '#22C55E' }, // Green
  { score: 50, color: '#DAD154' }, // Yellow-green
  { score: 70, color: '#FF7950' }, // Orange
  { score: 90, color: '#FF4343' }  // Red
];

export const getSeverityColor = (severity: number): string => {
  // Clamp severity between 0 and 100
  const clampedSeverity = Math.max(0, Math.min(100, severity));
  
  // If score is at or below 10, return green
  if (clampedSeverity <= 10) {
    return colorStops[0].color;
  }
  
  // If score is at or above 90, return red
  if (clampedSeverity >= 90) {
    return colorStops[3].color;
  }
  
  // Find the two color stops to interpolate between
  let lowerStop = colorStops[0];
  let upperStop = colorStops[1];
  
  for (let i = 0; i < colorStops.length - 1; i++) {
    if (clampedSeverity >= colorStops[i].score && clampedSeverity <= colorStops[i + 1].score) {
      lowerStop = colorStops[i];
      upperStop = colorStops[i + 1];
      break;
    }
  }
  
  // Calculate interpolation factor
  const factor = (clampedSeverity - lowerStop.score) / (upperStop.score - lowerStop.score);
  
  // Parse hex colors
  const parseHex = (hex: string) => ({
    r: parseInt(hex.slice(1, 3), 16),
    g: parseInt(hex.slice(3, 5), 16),
    b: parseInt(hex.slice(5, 7), 16)
  });
  
  const lowerColor = parseHex(lowerStop.color);
  const upperColor = parseHex(upperStop.color);
  
  // Interpolate RGB values
  const r = Math.round(lowerColor.r + (upperColor.r - lowerColor.r) * factor);
  const g = Math.round(lowerColor.g + (upperColor.g - lowerColor.g) * factor);
  const b = Math.round(lowerColor.b + (upperColor.b - lowerColor.b) * factor);
  
  return `rgb(${r}, ${g}, ${b})`;
};